import React from 'react';
import PropTypes from 'prop-types';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { useLocale } from 'hooks';
import MuiCalendar from './MuiCalendar';
import { CalendarContainer } from './style';

function Calendar({ className, ...rest }) {
  return (
    <CalendarContainer className={className}>
      <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={useLocale()}>
        <MuiCalendar {...rest} />
      </LocalizationProvider>
    </CalendarContainer>
  );
}

Calendar.propTypes = {
  className: PropTypes.string
};

export default Calendar;
